import script from "./Rooms.vue?vue&type=script&setup=true&lang=js"
export * from "./Rooms.vue?vue&type=script&setup=true&lang=js"

import "./Rooms.vue?vue&type=style&index=0&id=daeb340a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-daeb340a"]])

export default __exports__